import React from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"
import { applyImageCloudinaryTransforms } from "utils/applyCloudinaryTransforms"

import Seo from "components/seo"
import ContentfulNavigation from "components/page-components/navigation"
import Grid from "./grid"
import Video from "./video"
import { Banner } from "./styles"

const RevitalizeVideos = ({ videos, selectedVideo }) => (
  <>
    <Seo
      title={selectedVideo ? selectedVideo.title : "revitalize video library"}
      description={
        selectedVideo
          ? selectedVideo.metaDescription
          : "Talks and discussions from mindbodygreen's revitalize events."
      }
      image={applyImageCloudinaryTransforms(
        selectedVideo ? selectedVideo.image : "https://res.mindbodygreen.com/img/evt/Pwnjvf0.jpg",
        "c_fill,g_auto,w_800,h_400,q_auto,f_auto,fl_lossy",
      )}
      robots="noindex"
      canonical={
        selectedVideo
          ? `${process.env.GATSBY_LOCAL_SITE}/revitalize/videos/${selectedVideo.url}`
          : `${process.env.GATSBY_LOCAL_SITE}/revitalize/videos`
      }
    />
    <ContentfulNavigation variant="revitalize" />
    {selectedVideo ? (
      <Video video={selectedVideo} />
    ) : (
      <ThemeProvider theme={componentThemeExtension("Dark Background Primary", false, true)}>
        <Banner heading={{ text: "Videos" }} />
      </ThemeProvider>
    )}
    {videos && <Grid allVideos={videos} selectedVideo={selectedVideo} />}
  </>
)

export default RevitalizeVideos
